export const USER_MULTI_VALUE_LIST_ITEM_AVATAR_SIZE = 24

export const USER_MULTI_VALUE_LIST_ITEM_TAG_AVATAR_SIZE = 16
